<div role="button" class="svg-icon svg-icon-selected">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" class="design-iconfont">
    <g
      stroke="#000"
      fill="none"
      fill-rule="evenodd"
      opacity=".69999999"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-opacity=".69828999"
    >
      <path d="M0 3L9 3 6.45688081 0" transform="translate(2.5 4)" />
      <path transform="rotate(180 7.75 9.5)" d="M2 9L11 9 8.45688081 6" />
    </g>
  </svg>
</div>

<style>
  .svg-icon {
    height: 1em;
    width: 1em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
